import { Button } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigateFunction } from 'react-router-dom';

import { useAppDispatch } from 'store/store';
import { setReportAnIssueMode } from 'store/ticket-service/ticketSlice';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

type LeaveReportAnIssueModalProps = {
	handleCloseModal: () => void;
	navigate: NavigateFunction;
};

export const LeaveReportAnIssueModal: FC<LeaveReportAnIssueModalProps> = ({ handleCloseModal, navigate }) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const [open, setOpen] = useState<boolean>(true);
	const dispatch = useAppDispatch();

	const handleClose = () => {
		handleCloseModal();
		setOpen(false);
	};

	return (
		<InfoModal
			isOpen={open}
			onClose={handleClose}
			image={<Error />}
			title={modalTranslate('reportAnIssueModal.title')}
			description={modalTranslate('reportAnIssueModal.description')}
			buttons={
				<>
					<Button
						sx={{
							height: '44px',
							width: { xs: '40%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="outlined"
						color="error"
					onClick={() => {
						dispatch(setReportAnIssueMode(false));
						navigate(-1);
					}}
					>
						{modalTranslate('reportAnIssueModal.leave')}
					</Button>
					<Button
						sx={{
							height: '44px',
							width: { xs: '40%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="contained"
						color="error"
						onClick={handleClose}
					>
						{modalTranslate('reportAnIssueModal.close')}
					</Button>
				</>
			}
		></InfoModal>
	);
};
